<template>
	<main class="vx-row">
		<div class="vx-col w-full md:w-5/6 lg:w-1/2">
			<div class="block mb-6">
				<a href="#" @click.prevent="changePassword" class="flex items-center">
					<img src="/assets/images/profile/account/verify.png" class="w-16 md:w-12 mr-4" alt="" />
					<strong class="text-dark">Ubah Kata Sandi</strong>
				</a>
			</div>
		</div>
	</main>
</template>
<script>
	export default {
		methods: {
			changePassword() {
				this.$emit('changePassword')
			},
			changePIN() {
				this.$emit('changePIN')
			}
		}
	}
</script>